module.exports = __webpack_public_path__ + "media/navi/phone_tell-1548d8fd.png";